<div class="rkpi-wrap">

  @if (loading) {
    <div class="rkpi-skeleton">
      @for (_ of [1,2,3,4]; track $index) { <div class="rkpi-sk-block"></div> }
    </div>
  }

  @if (!loading && config) {

    <!-- ── Fila superior: KPIs grandes ── -->
    <div class="rkpi-hero-row">

      <!-- Ratio principal -->
      <div class="rkpi-hero rkpi-hero--ratio">
        <span class="rkpi-hero__label">Índice de presencia</span>
        <span class="rkpi-hero__value" [style.color]="dominanceColor">{{ ratioLabel }}</span>
        <span class="rkpi-hero__sub">{{ ratioSubLabel }}</span>
        <div class="rkpi-hero__bar-wrap">
          @let postStat = tagStats | findTag: 'postobon';
          @let compStat = tagStats | findTag: 'competencia';
          @if (postStat && compStat) {
            <div class="rkpi-presence-bar">
              <div class="rkpi-presence-bar__seg rkpi-presence-bar__seg--post"
                   [style.flex]="postStat.total"
                   title="Postobon: {{ postStat.total }}">
                <span>P {{ postStat.pct }}%</span>
              </div>
              <div class="rkpi-presence-bar__seg rkpi-presence-bar__seg--comp"
                   [style.flex]="compStat.total"
                   title="Competencia: {{ compStat.total }}">
                <span>C {{ compStat.pct }}%</span>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Objetos totales -->
      <div class="rkpi-hero rkpi-hero--sm">
        <span class="rkpi-hero__label">Objetos detectados</span>
        <span class="rkpi-hero__value">{{ totalObjects | number }}</span>
        <span class="rkpi-hero__sub">{{ totalImages }} imágenes · ~{{ avgObjPerImage }} c/u</span>
      </div>

      <!-- Others (sin clasificar) -->
      <div class="rkpi-hero rkpi-hero--sm" [class.rkpi-hero--warn]="othersPct > 30">
        <span class="rkpi-hero__label">Sin clasificar ("Others")</span>
        <span class="rkpi-hero__value"
              [style.color]="othersPct > 30 ? '#f59e0b' : '#4ade80'">
          {{ othersPct }}%
        </span>
        <span class="rkpi-hero__sub">{{ othersTotal | number }} objetos no identificados</span>
      </div>

    </div>

    <!-- ── Tabla de stats por tag ── -->
    <div class="rkpi-tag-table">
      <div class="rkpi-tag-table__head">
        <span>Tag</span>
        <span>Total</span>
        <span>Nombrados</span>
        <span>Others</span>
        <span>Score prom.</span>
        <span>Alta conf. (≥90%)</span>
        <span>Presencia</span>
      </div>

      @for (s of tagStats; track trackByKey($index, s)) {
        <div class="rkpi-tag-row" [style.--tc]="s.color" [style.--bg]="s.bg">
          <!-- Tag -->
          <div class="rkpi-tag-row__tag">
            <span class="rkpi-tag-pill" [style.background]="s.bg" [style.color]="s.color">
              {{ s.label }}
            </span>
          </div>
          <!-- Total -->
          <span class="rkpi-tag-row__num rkpi-tag-row__num--main">{{ s.total | number }}</span>
          <!-- Nombrados -->
          <span class="rkpi-tag-row__num">{{ s.named | number }}</span>
          <!-- Others -->
          <span class="rkpi-tag-row__num" [class.rkpi-warn]="s.others > s.named">
            {{ s.others | number }}
            @if (s.others > 0) {
              <small>({{ (s.others / s.total * 100).toFixed(0) }}%)</small>
            }
          </span>
          <!-- Score -->
          <span class="rkpi-tag-row__score" [style.color]="scoreColor(s.avgScore)">
            {{ scorePct(s.avgScore) }}
          </span>
          <!-- Alta confianza -->
          <span class="rkpi-tag-row__num">
            {{ s.highConf | number }}
            <small>({{ (s.highConf / s.total * 100).toFixed(0) }}%)</small>
          </span>
          <!-- Barra presencia -->
          <div class="rkpi-tag-row__bar-wrap">
            <div class="rkpi-tag-row__bar">
              <div class="rkpi-tag-row__bar-fill"
                   [style.width.%]="s.barW"
                   [style.background]="s.color">
              </div>
            </div>
            <span class="rkpi-tag-row__pct">{{ s.pct }}%</span>
          </div>
        </div>
      }
    </div>

  }

</div>
